import { render } from "./plain.vue?vue&type=template&id=1e7ceb3e"
import script from "./plain.vue?vue&type=script&lang=js"
export * from "./plain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__